<template>
  <div>
    <v-tabs
      v-model="tabs"
      fixed-tabs
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-if=" $store.state.user.user_role_id == 1"
        href="#my-stores"
        class="primary--text"
      >
        Minhas lojas
      </v-tab>

      <v-tab
        href="#attending-stores"
        class="primary--text"
        v-if=" $store.state.user.user_role_id == 2"
      >
        Lojas que eu atendo
      </v-tab>

      <v-tab
        href="#invited-stores"
        class="primary--text"
        v-if=" $store.state.user.user_role_id == 2"
      >
        Convites
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
       
       <v-tab-item value="my-stores">
        <StoresTable 
          @edit="(item) => $emit('edit', item)"
          @configure="configure"
          @remove="remove"
          :owner="true" :items="$store.state.stores"/>
       </v-tab-item>
       
       <v-tab-item value="attending-stores">
        <AttendingList 
          @attendStore="attendStore" 
          :owner="false" 
          :key="attendingStores" 
          :items="$store.state.attending_stores"
        />
       </v-tab-item>
       <v-tab-item value="invited-stores">
        <Invites @updateContent="updateContent" />
       </v-tab-item>
    </v-tabs-items>
    

    <v-dialog
      v-if="configureStore"
      v-model="configureDialog"
      max-width="850"
    >
      <v-card>
        <v-card-title class="headline">Instruções de integração</v-card-title>

        <v-card-text v-if="configureStore">
          <p>Dentro da plataforma, localize a seção de Webhooks e configure as seguintes URLs para cada evento:</p>
          <p>Evento: <strong>todos</strong></p>
          <div>
            <input type="hidden" id="pb-url" :value="pubUrl">
            <span v-if="!successCopy">{{pubUrl}}</span>
          </div>
          <v-btn @click="copy()" title="Configurar integração" dark small color="blue">
            <v-icon >
              mdi-content-copy
            </v-icon>
            Copiar Url
          </v-btn>
          <p>Após concluir a etapa acima, faça o seguinte:</p>
          <ul>
            <li>Clique em <strong>Conversão -> Atendentes</strong>  e edite os usuários que terão permissão de atendimento aos eventos da loja.</li>
            <li>Clique em <strong>Conversão -> Mensagens </strong> e configure as mensagens iniciais enviadas aos clientes.</li>
          </ul>
        </v-card-text>
        
        <v-card-text v-if="configureStore && configureStore.sale_platform.name === 'hotmart'">
        </v-card-text>

        

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn            
            text
            @click="configureDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import StoresTable from './Table.vue';
  import Invites from './Invites.vue';
  import AttendingList from './AttendingList';
export default {

  name: 'List',
  created () {
    this.$store.dispatch('fetchStores');
    this.$store.dispatch('fetchAttendingStores');
  },
  components: {
    StoresTable,
    Invites,
    AttendingList
  },
  methods: {
    remove(data) {
      if (confirm('Tem certeza que quer apagar a loja e todas suas transações?')) {
        this.$store.dispatch('deleteStore', {params: {id: data}})
      }
    },
    attendStore(store) {
      this.$router.push(`/store/attend/${store.uuid}`)
    },
    edit(item) {      
      this.$emit('edit', item);
    },
    configure(store) {
      this.configureStore = store;      
      this.pubUrl = `https://app.manyconvert.com/api/postbacks/${store.sale_platform.name}/${this.$store.state.user.id}/${this.configureStore.uuid}`;
      this.configureDialog = true;
    },
    copy() {
      const toCopy = document.querySelector('#pb-url');
      toCopy.setAttribute('type', 'text');
      toCopy.select();
      try {
        this.successCopy = document.execCommand('copy');
        if (this.successCopy) {
          this.$store.commit('alertSuccess', 'Url copiada para a área de transferência!');
        }
      } catch (err) {
        alert('Falha ao copiar a URL, por favor copie manualmente.');
      }
    },
    updateContent() {
      this.attendingStores++;
      this.$store.dispatch('fetchAttendingStores');
    }
  },
  data () {
    return {
      search: '',
      configureStore: false,
      configureDeialog: false,
      successCopy: false,
      pubUrl: '',      
      headers: [
        {text: 'Nome', value: 'name'},
        {text: 'Sigla', value: 'abbr'},
        {text: 'Superboleto', value: 'superboleto'},
        {text: '', value: ''}
      ],
      tabs: null,
      attendingStores: 0
    }
  }
}
</script>

<style lang="css" scoped>
input {
  min-width: 90%;
  display: block;
  margin: 0;
  padding: 0;
}
</style>